const Request = {
  DBInfo: "/Tables/Answer/Info",
  List: "/Tables/Answer/List",
  Add: "/Tables/Answer/Add",
  Delete: "/Tables/Answer/Delete",
  Edit: "/Tables/Answer/Edit",
  Export: "/Tables/Answer/Export",
  Import: "/Tables/Answer/Import",
  DeleteBulk: "/Tables/Answer/DeleteBulk",
};

let exports = {
  Request
};

export default exports;